import { WorkflowEdge, WorkflowNode } from "lib/types/workflow"

import { LAYOUT_BRANCH_OFFSET, LAYOUT_Y_STEP, NODE_W } from "../constants"
import { getHandleOffset } from "./geometry"

export const computeLayout = (
  nodes: WorkflowNode[],
  edges: WorkflowEdge[]
): Map<string, { x: number; y: number }> => {
  const positions = new Map<string, { x: number; y: number }>()

  const childrenMap = new Map<string, { target: string; handle: string }[]>()
  for (const edge of edges) {
    const list = childrenMap.get(edge.source) ?? []
    list.push({ target: edge.target, handle: edge.sourceHandle ?? "output" })
    childrenMap.set(edge.source, list)
  }

  const trigger = nodes.find((n) => n.type === "trigger")
  if (!trigger) return positions

  const nodeMap = new Map(nodes.map((n) => [n.id, n]))

  const walk = (nodeId: string, x: number, y: number) => {
    if (positions.has(nodeId)) return
    positions.set(nodeId, { x, y })

    const children = childrenMap.get(nodeId) ?? []
    const node = nodeMap.get(nodeId)

    if (node?.type === "condition" && children.length === 2) {
      const trueChild = children.find((c) => c.handle === "true-output")
      const falseChild = children.find((c) => c.handle === "false-output")
      if (trueChild) walk(trueChild.target, x - LAYOUT_BRANCH_OFFSET, y + LAYOUT_Y_STEP)
      if (falseChild) walk(falseChild.target, x + LAYOUT_BRANCH_OFFSET, y + LAYOUT_Y_STEP)
    } else {
      for (const child of children) {
        const handleCenterX = x + getHandleOffset(node?.type, child.handle)
        const childX = handleCenterX - NODE_W / 2
        walk(child.target, childX, y + LAYOUT_Y_STEP)
      }
    }
  }

  walk(trigger.id, 250, 0)

  let maxY = 0
  for (const pos of positions.values()) {
    if (pos.y > maxY) maxY = pos.y
  }
  for (const node of nodes) {
    if (!positions.has(node.id)) {
      maxY += LAYOUT_Y_STEP
      positions.set(node.id, { x: 250, y: maxY })
    }
  }

  return positions
}
